/* eslint-disable react/destructuring-assignment */
import React, { useMemo } from 'react';
import AttendeeNoteButton from './DataTable/components/AttendeeNoteButton';

const CreateTableData = (setNoteModalVisibility) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Notes',
        accessor: 'notes',
        key: 'notes',
        disableGlobalFilter: true,
        sticky: 'left',
        canSort: false,
        Cell: data => <AttendeeNoteButton setModalVisbility={setNoteModalVisibility} {...data.row.original} />,
        isTableColumn: true,
      },
      {
        Header: 'Client',
        accessor: 'client',
        key: 'client',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Event Name',
        accessor: 'eventName',
        key: 'eventName',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Service Provider Name',
        accessor: 'serviceProviderName',
        key: 'serviceProviderName',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Service Provider Email Address',
        accessor: 'serviceProviderEmailAddress',
        key: 'serviceProviderEmailAddress',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'PAYCE Event ID',
        accessor: 'payceEventId',
        key: 'payceEventId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'PAYCE Attendee ID',
        accessor: 'payceEventAttendeeId',
        key: 'payceEventAttendeeId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Client Event ID',
        accessor: 'clientEventId',
        key: 'clientEventId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Client Attendee ID',
        accessor: 'clientAttendeeId',
        key: 'clientAttendeeId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Start Date',
        accessor: 'startDate',
        key: 'startDate',
        disableGlobalFilter: true,
        filterType: 'date',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'End Date',
        accessor: 'endDate',
        key: 'endDate',
        disableGlobalFilter: true,
        filterType: 'date',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Status',
        accessor: 'currentStatus',
        key: 'currentStatus',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Meeting Organiser Email Address',
        accessor: 'meetingOrganiserEmailAddress',
        key: 'meetingOrganiserEmailAddress',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Approver Email Address',
        accessor: 'paymentApproverEmailAddress',
        key: 'paymentApproverEmailAddress',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Payee Name',
        accessor: 'payeeName',
        key: 'payeeName',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Contracted Fee',
        accessor: 'contractedFee',
        key: 'contractedFee',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Fee Total',
        accessor: 'feeTotal',
        key: 'feeTotal',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Confirmed Fee',
        accessor: 'confirmedFee',
        key: 'confirmedFee',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Expenses Total',
        accessor: 'expensesTotal',
        key: 'expensesTotal',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'VAT Value',
        accessor: 'vatValue',
        key: 'vatValue',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Total Payment',
        accessor: 'totalPayment',
        key: 'totalPayment',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Currency',
        accessor: 'currencyCode',
        key: 'currencyCode',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Expenses Allowed',
        accessor: 'expensesAllowable',
        key: 'expensesAllowable',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Invoice Required',
        accessor: 'invoiceRequired',
        key: 'invoiceRequired',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Invoice Submitted',
        accessor: 'invoicesSubmitted',
        key: 'invoicesSubmitted',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Service Confirmed',
        accessor: 'serviceConfirmed',
        key: 'serviceConfirmed',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Payment Instalment',
        accessor: 'paymentInstalment',
        key: 'paymentInstalment',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Payment Blocked',
        accessor: 'blockPaymentResult',
        key: 'blockPaymentResult',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Event Type',
        accessor: 'eventTypeName',
        key: 'eventTypeName',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
      {
        Header: 'Attendee Type',
        accessor: 'attendeeTypeName',
        key: 'attendeeTypeName',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: false,
        isTableColumn: true,
      },
    ],
    [],
  );

  const reactTableData = { tableHeaderData: columns.filter(x => x.isTableColumn), filters: columns, tableRowsData: [] };

  return reactTableData;
};

export const CreatePaymentTableData = () => {
  const columns = useMemo(
    () => [
      {
        Header: 'Date Paid',
        accessor: 'datePaidUtc',
        key: 'datePaidUtc',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'date',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Payment Year',
        accessor: 'paymentYear',
        key: 'paymentYear',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'dropdown',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Client',
        accessor: 'client',
        key: 'client',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'dropdown',
        isTableColumn: true,
      },
      {
        Header: 'Service Organisation Name',
        accessor: 'serviceOrgName',
        key: 'serviceOrgName',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
        key: 'lastName',
        disableGlobalFilter: true,
        sticky: 'left',
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'First Name',
        accessor: 'firstName',
        key: 'firstName',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Email',
        accessor: 'email',
        key: 'email',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Consent',
        accessor: 'consentStatus',
        key: 'consentStatus',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'External data source ID',
        accessor: 'externalDataSourceId',
        key: 'externalDataSourceId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Engagement Name',
        accessor: 'eventName',
        key: 'eventName',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Client Event ID',
        accessor: 'clientEventId',
        key: 'clientEventId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'PAYCE Event ID',
        accessor: 'payceEventId',
        key: 'payceEventId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Client Attendee ID',
        accessor: 'clientAttendeeId',
        key: 'clientAttendeeId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Payce Attendee ID',
        accessor: 'payceAttendeeId',
        key: 'payceAttendeeId',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Attendee Type',
        accessor: 'attendeeType',
        key: 'attendeeType',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Attendee Sub-type',
        accessor: 'attendeeSubtype',
        key: 'attendeeSubtype',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'External TOV',
        accessor: 'externalTOV',
        key: 'externalTOV',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Fees',
        accessor: 'fees',
        key: 'fees',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Expenses for Service',
        accessor: 'expensesForService',
        key: 'expensesForService',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Registration Fees',
        accessor: 'registrationFees',
        key: 'registrationFees',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Expenses for Attending',
        accessor: 'expensesForAttending',
        key: 'expensesForAttending',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Grants and Donations',
        accessor: 'grantsAndDonations',
        key: 'grantsAndDonations',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Sponsorship',
        accessor: 'sponsorship',
        key: 'sponsorship',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'VAT',
        accessor: 'vat',
        key: 'vat',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Income tax',
        accessor: 'incomeTax',
        key: 'incomeTax',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Total',
        accessor: 'total',
        key: 'total',
        disableGlobalFilter: true,
        filterType: 'text',
        Cell: row => <div style={{ textAlign: 'right' }}>{row.value}</div>,
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Currency Code',
        accessor: 'currencyCode',
        key: 'currencyCode',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Country Code',
        accessor: 'countryCode',
        key: 'countryCode',
        disableGlobalFilter: true,
        filterType: 'text',
        canSort: true,
        isTableColumn: true,
      },
      {
        Header: 'Account Type',
        accessor: 'payeeAccountType',
        key: 'payeeAccountType',
        disableGlobalFilter: true,
        filterType: 'dropdown',
        canSort: true,
        isTableColumn: true,
      },
    ],
    [],
  );

  const reactTableData = { tableHeaderData: columns.filter(x => x.isTableColumn), filters: columns, tableRowsData: [] };

  return reactTableData;
};

export default CreateTableData;
